import React from 'react';
import { Box } from '@mui/material';

import FormControls from '../MUI/FormControls/FormControls';

const statusOptions = [
  { id: 'Active', title: 'Active' },
  { id: 'Inactive', title: 'Inactive' },
  { id: 'Deleted', title: 'Deleted' },
  { id: 'New', title: 'New' },
];

const StatusSelectFormField = (props) => {
  const { currentStatus, onChange, label = 'Status' } = props;

  return (
    // <Box sx={{ width: '15rem' }}>
    <Box>
      <FormControls.SelectControl
        name='status'
        label={label}
        value={currentStatus}
        onChange={onChange}
        options={statusOptions}
      />
    </Box>
  );
};

export default StatusSelectFormField;
